var $ = jQuery.noConflict();
jQuery(document).ready(function() {
    isElementExist(".popup-video", initVideoPopup);
    isElementExist(".popup", initPopup);
    initCustomSelects();
    isElementExist(".location-tabs", initLocationTabs);
    isElementExist(".steps-tabs", initStepTabs);
    isElementExist(".go-to-step2", clickGoToStepLinks2);
    isElementExist(".quote-step-validation", validateQuoteSteps);
    isElementExist(".input-date", initMobiscroll);
    initAccordion();
    initFaqFilter();

    // new for coupons/header sub-menus
    isElementExist(".coupon-modal", initCouponModal);
    isElementExist(".coupon-quote-modal", initCouponQuoteModal);
    isElementExist(".show-hidden-text-btn", toggleHiddenText);
    isElementExist("#coupon-company-select", filterCouponCompany);
    isElementExist("#modal-mobile-menu .has-sub-menu", toggleMobileSubMenus);

    // in the news
    isElementExist(".news-year-select", filterNewsYear);
});

// Helper if element exist then call function
function isElementExist(_el, _cb) {
    const elem = document.querySelector(_el);

    try {
        if (document.body.contains(elem)) {
            _cb();
        }
    } catch (e) {
        console.log(e);
    }
}


function initMobiscroll() {
    mobiscroll.settings = {  // More info about themeVariant: https://docs.mobiscroll.com/4-10-3/javascript/datetime#opt-themeVariant
        dateFormat: "m/d/yy",
        lang: "en", 
        theme: "autoslash"
    };

    // example of how to use parsley.js to validate same day rental, not hooked up currently.
    window.Parsley.addValidator("sameDay",
        {
            requirementType: "string",
            validateString: function(value) {
                const inputEl = document.querySelector("[data-parsley-same-day]");
                const inputString = value;
                const today = new Date();
                const isToday = (today.toDateString() == new Date(inputString).toDateString());

                console.log(isToday);

                if (isToday) {
                    $(inputEl).siblings(".input-error-message").addClass("_active");
                } else {
                    $(inputEl).siblings(".input-error-message").removeClass("_active");
                }

                return !isToday;
            },
            messages: {
            }
        });
}

function handleValidate(element) {
    const stepContainer = element.closest(".swiper-slide");
    const inputValidFields = stepContainer.querySelectorAll(".input-validation .input-control");
    let isValid = true;

    if (inputValidFields.length) {
        inputValidFields.forEach(inputField => {
            const isFieldSelect = inputField.classList.contains("input-control-select");
            const field = isFieldSelect ? inputField.querySelector("select") : inputField.querySelector("input");

            if ((isFieldSelect) && (!field.value)) {
                field.closest(".input-validation").classList.add("input-validation-error");
                isValid = false;
            }

            if ((!isFieldSelect) && ($(field).parsley().validate() !== true)) {
                isValid = false;
            }
        });
    }

    return isValid;
}

function clickGoToStepLinks2() {
    const goToStepLinks = document.querySelectorAll(".go-to-step2");

    goToStepLinks.forEach(link => {
        link.addEventListener("click",
            (e) => {
                e.preventDefault();
                const goToStepBtn = e.target;
                const goToStepName = goToStepBtn.dataset.stepGo;
                const hideStepName = goToStepBtn.dataset.hideStep;
                const stepContainer = goToStepBtn.closest(".swiper-slide");
                let isValid = true;
                let isGoNextStepBtn = false;
                const inputValidFields = stepContainer.querySelectorAll(".input-validation .input-control");

                // check btn inside nav pane
                isGoNextStepBtn = (goToStepBtn.classList.contains("btn")) ? true : false;

                // check validation fields
                if (isGoNextStepBtn && inputValidFields.length) {
                    inputValidFields.forEach(inputField => {
                        const isFieldSelect = inputField.classList.contains("input-control-select");
                        const field = isFieldSelect
                            ? inputField.querySelector("select")
                            : inputField.querySelector("input");

                        if ((isFieldSelect) && (!field.value)) {
                            field.closest(".input-validation").classList.add("input-validation-error");
                            isValid = false;
                        }

                        if ((!isFieldSelect) && ($(field).parsley().validate() !== true)) {
                            isValid = false;
                        }
                    });
                }

                if (isValid) {
                    goToStep2(hideStepName, goToStepName);
                }
            });
    });
}

function goToStep2(_hideStep, _stepName) {
    $(`.${_stepName}`).show();
    $(`.${_hideStep}`).hide();
}

function validateQuoteSteps() {
    debugger;
    $(".quote-step-validation").each(function() {
        const quoteStep = $(this);
        console.log(quoteStep);
    });
}

function initCustomSelects() {
    $(".custom-select").each(function() {
        const selectPlaceholder = $(this).find("option:selected").text();

        $(this).selectize({
            create: false,
            // sortField: 'text',
            placeholder: selectPlaceholder,

            onChange: function(value) {
                const obj = $(this)[0];
                obj.$control.closest(".input-group").removeClass("input-validation-error");
            }
        });
    });

    $(".custom-select-search-from-start").each(function() {
        const selectPlaceholder = $(this).find("option:selected").text();

        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(search, pos) {
                return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
            };
        }

        $(this).selectize({
            create: false,
            placeholder: selectPlaceholder,
            openOnFocus: true,
            items: [""],

            score: function(search) {
                const score = this.getScoreFunction(search);
                return function(item) {
                    return item.text
                        .toLowerCase()
                        .startsWith(search.toLowerCase())
                        ? 1
                        : 0;
                };
            },

            onChange: function(value) {
                const obj = $(this)[0];
                obj.$control.closest(".input-group").removeClass("input-validation-error");
            }
        });
    });

    $(".custom-select-no-search").each(function() {
        const selectPlaceholder = $(this).find("option:selected").text();

        $(this).selectize({
            create: false,
            placeholder: selectPlaceholder,
            onInitialize: function() {
                this.$control_input.attr("readonly", true);
            }
        });
    });
}


/* ***************** */
/* *** help menu *** */

function initSliderHelpMenu() {
    const goToSlideLinks = document.querySelectorAll("#modal-help-menu .help-menu-slider a");
    var goBackBtn = document.querySelector("#modal-help-menu .btn-back-help-menu");

    var helpMenuSlider = new Swiper(".help-menu-slider",
        {
            speed: 200,
            effect: "fade",
            allowTouchMove: false,
        });

    goBackBtn.style.display = "none";

    goBackBtn.addEventListener("click",
        (e) => {
            e.preventDefault();
            var activeSlide = helpMenuSlider.slides[helpMenuSlider.activeIndex];
            helpMenuSlider.slideTo(activeSlide.dataset.itemCameFrom);
        });

    helpMenuSlider.on("slideChange",
        function() {
            if (helpMenuSlider.realIndex == 0) {
                goBackBtn.style.display = "none";
            } else {
                goBackBtn.style.display = "block";
            }
        });

    helpMenuSlider.on("transitionEnd",
        function() {
            const activeSlide = helpMenuSlider.slides[helpMenuSlider.activeIndex];
            const dataCameFrom = activeSlide.dataset.itemCameFrom;

            if (dataCameFrom !== "0") {
                activeSlide.dataset.itemCameFrom = helpMenuSlider.previousIndex;
            }
        });

    clickHelpMenuStepLinks();
}

function clickHelpMenuStepLinks() {
    const goToStepLinks = document.querySelectorAll("#modal-help-menu .go-to-item");

    goToStepLinks.forEach(link => {
        link.addEventListener("click",
            (e) => {
                e.preventDefault();
                const stepName = e.target.dataset.itemGo;

                goToHelpMenuStep(stepName);
            });
    });
}

function goToHelpMenuStep(_stepName) {
    const helpMenuSlider = document.querySelector(".help-menu-slider").swiper;

    for (let i = 0; i < helpMenuSlider.slides.length; i++) {
        if (helpMenuSlider.slides[i].classList.contains(_stepName)) {
            helpMenuSlider.slideTo(i);
        }
    }
}

function initPopup() {
    $(".popup").magnificPopup({
        type: "inline",
        preloader: false,
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: "auto",
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 100,
        closeMarkup: '<button title="close" type="button" class="mfp-close"></button>',
        callbacks: {
            open: function() {
                initSliderHelpMenu();
            },
        }
    });

    $(".btn-close-modal").on("click",
        (e) => {
            e.preventDefault();
            $.magnificPopup.close();
        });

    $(".popup-from-top").magnificPopup({
        type: "inline",
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: "auto",
        closeBtnInside: true,
        preloader: false,

        midClick: true,
        mainClass: "mfp-move-from-top",

        callbacks: {
            open: function() {
                document.querySelector(".mobile-logo").style.opacity = "0";
            },
            close: function() {
                document.querySelector(".mobile-logo").style.opacity = "1";
            }
        },
    });
}

function initVideoPopup() {
    $(".popup-video").magnificPopup({
        type: "iframe",
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
                '</div>',
            patterns: {
                youtube: {
                    index: 'youtube.com/',
                    id: 'v=',
                    src: 'https://www.youtube.com/embed/%id%?autoplay=1'
                }
            }
        },
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
    });
}

function initLocationTabs() {
    let activeTab = 1;

    if ($("#local-tab").hasClass("active")) {
        activeTab = 2;
    }

    $(".location-tabs").tabslet({
        animation: true,
        active: activeTab
    });
}

function initStepTabs() {
    const activeTabNum = $(".steps-tabs").data("active-tab");

    $(".steps-tabs").tabslet({
        active: activeTabNum,
        animation: true
    });
}

function initAccordion() {
    jQuery(".faq-accordion").slideAccordion({
        opener: ".opener",
        slider: ".slide",
        animSpeed: 300
    });
}

function initFaqFilter() {
    var form = "#faq-search-form",
        activeClass = "input-active",
        lastFilterVal;

    $(".faq-accordion .btt-btn").click(function(e) {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });

    $(".clear-btn").on("click",
        function(e) {
            e.preventDefault();
            $(form).find(".input").val("");
            $(form).removeClass(activeClass);
            $(".faq-accordion .mid-title").hide();
            $(".faq-block").removeClass("search-failed search-matched");
            $(".faq-accordion .acc-box").each(function() {
                $(this).show();
                $(this).removeHighlight(lastFilterVal);
            });
        });

    $(form).on("keyup",
        ".input",
        function(e) {
            if ($(this).val() && $(this).val() != "") {
                $(form).addClass(activeClass);
            } else {
                $(form).removeClass(activeClass);
            }
        });

    $(form).on("submit",
        function(e) {
            e.preventDefault();
            filterResults();
        });

    function filterResults() {
        var filterVal = $(form).find(".input").val(),
            countRes = 0,
            countTotal = 0;

        $(".faq-accordion .mid-title").show();

        $(".faq-accordion .acc-box").each(function() {
            $(this).show();
            $(this).removeHighlight(filterVal);

            // If the list item does not contain the text phrase fade it out
            if (filterVal && filterVal != "") {
                if ($(this).text().search(new RegExp(filterVal, "gi")) > 0) {
                    $(this).show();
                    $(this).highlight(filterVal);
                    $(this).insertAfter(".faq-accordion .mid-title.res");
                    countRes++;
                } else {
                    $(this).insertAfter(".faq-accordion .mid-title.other");
                }
            } else {
                $(this).show();
            }
            countTotal++;
        });
        if (countRes > 0) {
            $(".faq-block").removeClass("search-failed");
            $(".faq-block").addClass("search-matched");
            $(".faq-accordion .mid-title.res").html(`<p>Search results for: <span>${filterVal}</span></p>`);
            if (countRes == countTotal) {
                $(".faq-accordion .mid-title.other").hide();
            }
        } else {
            $(".faq-accordion .mid-title").hide();
            $(".faq-block").removeClass("search-matched");
            $(".faq-block").addClass("search-failed");
        }

        lastFilterVal = filterVal;
    }
}

function toggleMobileSubMenus() {
    const subMenus = document.querySelectorAll("#modal-mobile-menu .has-sub-menu");

    subMenus.forEach(subMenu => {
        subMenu.addEventListener("click",
            (e) => {
                e.preventDefault();

                subMenu.classList.toggle("_active");
            });
    });

    $(".is-sub-menu").click(function(event) {
        event.stopPropagation();
    });
}

function filterCouponCompany() {
    const companySelect = document.querySelector("#coupon-company-select");
    const coupons = document.querySelectorAll(".coupons-content .coupon");

    const selectize = $("#coupon-company-select")[0].selectize.on("change",
        (val) => {
            if (val == "All") {
                window.location.href = "/coupons";
            } else {
                window.location.href = `/coupons/${val.toLowerCase()}`;
            }

            //coupons.forEach(coupon => {
            //    let companyName = coupon.dataset.company;

            //    if (companyName == val || val == "All") {
            //        coupon.style.display = "grid";
            //    } else {
            //        coupon.style.display = "none";
            //    }
            //});
        });
}


function initCouponModal() {
    $(".coupon-modal").magnificPopup({
        type: "inline",
        preloader: false,
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: "auto",
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 100,
        closeMarkup: '<button title="close" type="button" class="mfp-close"></button>',
    });
}


function initCouponQuoteModal() {
    $(".coupon-quote-modal").magnificPopup({
        type: "inline",
        preloader: false,
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: "auto",
        closeBtnInside: false,
        preloader: false,
        midClick: true,
        alignTop: false,
        removalDelay: 100,
    });
}


function toggleHiddenText() {
    const showHiddenTextBtns = document.querySelectorAll(".show-hidden-text-btn");
    const hideHiddenTextBtns = document.querySelectorAll(".hide-hidden-text-btn");

    showHiddenTextBtns.forEach(btn => {
        btn.addEventListener("click",
            (e) => {
                e.preventDefault();
                const containerId = btn.dataset.showId;

                const hiddenContentContainer = document.querySelector(`#hidden-content-${containerId}`);
                hiddenContentContainer.classList.add("_active");

                const couponTerms = btn.closest(".coupon-terms");

                if (couponTerms) {
                    couponTerms.querySelector(".coupon-terms-title").classList.add("_active");
                }
            });
    });

    hideHiddenTextBtns.forEach(btn => {
        btn.addEventListener("click",
            (e) => {
                e.preventDefault();
                const containerId = btn.dataset.hideId;

                const hiddenContentContainer = document.querySelector(`#hidden-content-${containerId}`);
                hiddenContentContainer.classList.remove("_active");

                const couponTerms = btn.closest(".coupon-terms");

                if (couponTerms) {
                    couponTerms.querySelector(".coupon-terms-title").classList.remove("_active");
                }
            });
    });
}

function filterNewsYear() {
    let newsYearSelects = document.querySelectorAll('select.news-year-select');
    let yearGroups = document.querySelectorAll('.news-year-group');

    let firstSelectSelectize = $(newsYearSelects[0])[0].selectize;
    let secondSelectSelectize = $(newsYearSelects[1])[0].selectize;

    firstSelectSelectize.on('blur', () => {
        let val = firstSelectSelectize.getValue();
        secondSelectSelectize.setValue(val);
        changeYear(val);
    });

    secondSelectSelectize.on('blur', () => {
        let val = secondSelectSelectize.getValue();
        firstSelectSelectize.setValue(val);
        changeYear(val);
    });

    function changeYear(_val) {
        yearGroups.forEach(yearGroup => {
            let filterNameList = yearGroup.dataset.groupId.split(',');
            let flagYearGroup = false;

            filterNameList.forEach(filterName => {
                if (filterName.trim() == _val) {
                    flagYearGroup = true;
                }
            });

            if (flagYearGroup) {
                yearGroup.style.display = "block";
            } else {
                yearGroup.style.display = "none";
            }
        });


        // fix select dropdown position
        const newsContainer = document.querySelector('.news-container');
        const newsControl = document.querySelectorAll('.news-control')[1];

        if (newsContainer.offsetHeight < 200) {
            newsControl.classList.remove('_bottom')
        } else {
            newsControl.classList.add('_bottom')
        }
    }

    changeYear(firstSelectSelectize.getValue());
}